function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "\uD83C\uDFA8 Icon color");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "desktop",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "home",
  transform: "translate(-899.000000, -1520.000000)",
  fill: "#BEC4DC"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-8",
  transform: "translate(-1.000000, 1150.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(884.000000, 121.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5-Copy",
  transform: "translate(0.000000, 218.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-12",
  transform: "translate(0.000000, 18.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.026316,17.0943474 C25.026316,17.0943474 18.5789474,24.9329768 18.5789474,28.4673907 C18.5789474,32.0018045 21.4655327,34.8670131 25.026316,34.8670131 C28.5870993,34.8670131 31.4736846,32.0018045 31.4736846,28.4673907 C31.4736846,24.9329768 25.026316,17.0943474 25.026316,17.0943474 Z M23.0513578,15.4011293 L25.026316,13 L27.0012742,15.4011293 C27.0600179,15.4725491 27.1629635,15.5995902 27.3038844,15.7764381 C27.5347074,16.066108 27.7908713,16.3937521 28.0661862,16.7536309 C28.8525898,17.7815808 29.6391849,18.8672755 30.377386,19.9671101 C30.9100607,20.7607339 31.3985655,21.5341615 31.8337166,22.2804284 C33.2488614,24.7073456 34.052632,26.7073122 34.052632,28.4673907 C34.052632,33.4728216 29.9954071,37.5000006 25.026316,37.5000006 C20.0572249,37.5000006 16,33.4728216 16,28.4673907 C16,26.7073122 16.8037706,24.7073456 18.2189154,22.2804284 C18.6540665,21.5341615 19.1425713,20.7607339 19.675246,19.9671101 C20.4134471,18.8672755 21.2000422,17.7815808 21.9864458,16.7536309 C22.2617607,16.3937521 22.5179246,16.066108 22.7487476,15.7764381 C22.8896685,15.5995902 22.9926141,15.4725491 23.0513578,15.4011293 Z M25.026316,31.4736846 C23.3694618,31.4736846 22.026316,30.1305388 22.026316,28.4736846 C22.026316,26.8168303 23.3694618,25.4736846 25.026316,25.4736846 C26.6831702,25.4736846 28.026316,26.8168303 28.026316,28.4736846 C28.026316,30.1305388 26.6831702,31.4736846 25.026316,31.4736846 Z",
  id: "\\uD83C\\uDFA8-Icon-color",
  transform: "translate(25.026316, 25.250000) scale(1, -1) translate(-25.026316, -25.250000) "
})))))));

var SvgIconeLocation = function SvgIconeLocation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "25px",
    viewBox: "0 0 19 25",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconeLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icone-location.4ac5ab1d.svg";
export { ForwardRef as ReactComponent };